import styled from "styled-components";
import Navbar from "../E-components/Navbar";
import Announcement from "../E-components/Announcement";
import Products from "../E-components/Products";
import Newsletter from "../E-components/Newsletter";
import Footer from "../E-components/Footer";
import { mobile } from "../responsive";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import React from "react";
const Container = styled.div``;

const Title = styled.h1`
  margin: 20px;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Filter = styled.div`
  margin: 20px;
  ${mobile({ width: "0px 20px", display: "flex", flexDirection: "column" })}
`;

const FilterText = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin-right: 20px;
  ${mobile({ marginRight: "0px" })}
`;

const Select = styled.select`
  padding: 10px;
  margin-right: 20px;
  ${mobile({ margin: "10px 0px" })}
`;
const Option = styled.option``;

const ProductList = () => {
  // using location hook
  const location = useLocation()
 const cat = location.pathname.split("/")[2] //split this string
 const [filters,setFilters] =useState({})//分顏色
 const [sort,setSort] =useState("最新的") //分順序排列 只有一排所以直接寫下面
 const handleFilters =(e)=>{
   const value =e.target.value
   setFilters({ //color:red, size:m
    ...filters, // spread operator [color:red,size:m]合在一起
    [e.target.name]:value //選一個名子會是上面的值
     
   })
 }

 return (
   <>
    <Container>
      <Navbar />
      <Announcement />
      <Title>{cat}</Title>
      <FilterContainer>
        <Filter>
          <FilterText>產品尺寸/顏色分類:</FilterText>
          <Select name="color" onChange={handleFilters}> 
            <Option disabled>
              顏色
            </Option>
            <Option value="white">白色</Option>
            <Option value="brown">棕色</Option>
            <Option value="burlywood">大地色</Option>
            <Option value="gray">灰色</Option>
            
          </Select>
          <Select name="size" onChange={handleFilters}>
            <Option disabled>
              Size
            </Option>
            <Option>XS</Option>
            <Option>S</Option>
            <Option>M</Option>
            <Option>L</Option>
            <Option>XL</Option>
          </Select>
        </Filter>
        <Filter>
          <FilterText>篩選產品:</FilterText>
          <Select  onChange={(e)=>setSort(e.target.value)}>
            <Option value="最新">最新</Option>
            <Option value="最高到最低">價格 (最高到最低)</Option>
            <Option value="最低到最高">價格 (最低到最高)</Option>
          </Select>
        </Filter>
      </FilterContainer>
      <Products cat = {cat} filters={filters} sort ={sort}/>
      <Newsletter />
      <Footer />
    </Container>
    </>
  );
};

export default ProductList;
